const getReceiverText = (message) => {
  const { receiverType } = message;
  const names = message.receiverId.map((user) => user.name);

  switch (receiverType) {
    case "ALL_RENTERS":
      return "所有住戶";
    case "ALL_NON_RENTERS":
      return "所有非住戶";
    case "ALL":
      return "所有人";
    default:
      return names.join(", ");
  }
};

export { getReceiverText };
